/**
 * Cannot use a namespace here because Typescript namespaces don't support re-exporting for some reason
 */
import { isServerSide } from 'src/utils/validators/isServerSide';
import { areIntegrationTestsRunning } from 'src/utils/validators/areIntegrationTestsRunning';
import { ClientConfigProvider } from '../ClientConfigProvider';

import { RouteConfigurationServiceDomain } from './domain';
export { RouteConfigurationServiceDomain as Domain };
export class ConfigProvider extends ClientConfigProvider {
    public getSafeCallbackUrl(callbackURL: string | null, currentPathname: string): string {
        if (!callbackURL) {
            if (currentPathname === RouteConfigurationServiceDomain.ApplicationRoute.AUTH_SIGNIN_BOUNCE) {
                // We cannot use the auth signin bounce as the callback URL because it will cause an infinite loop
                return RouteConfigurationServiceDomain.ApplicationRoute.DASHBOARD_BOUNCE;
            }
            return currentPathname;
        }
        const isAllowedExternal = RouteConfigurationServiceDomain.ALLOWED_EXTERNAL_CALLBACK_URLS.includes(
            callbackURL as RouteConfigurationServiceDomain.ExternalRoute
        );
        const isInternalRoute =
            callbackURL.startsWith('/homeloans/mortgage/') &&
            callbackURL !== RouteConfigurationServiceDomain.ApplicationRoute.AUTH_SIGNIN_BOUNCE;
        if (isAllowedExternal || isInternalRoute) {
            return callbackURL;
        }
        return currentPathname;
    }
    public get zillowDomain(): RouteConfigurationServiceDomain.ZillowDomain {
        if (this.runtimeConfig.isLowerEnvironment) {
            return RouteConfigurationServiceDomain.ZillowDomain.NON_PRODUCTION;
        }
        return RouteConfigurationServiceDomain.ZillowDomain.PRODUCTION;
    }

    public get zillowHomeLoansHomePage(): string {
        return `${this.zillowDomain}${RouteConfigurationServiceDomain.ExternalRoute.HOMELOANS_LANDING_PAGE}`;
    }

    public get newUserDestination(): string {
        if (!this.runtimeConfig.isLowerEnvironment || isServerSide() || !areIntegrationTestsRunning()) {
            return `${this.zillowDomain}${RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD}`;
        }
        // return local so Cypress can handle prequal on MRs and staging.
        return RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD;
    }
}
